import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import Contact from '../../contacts/contact-api-client';

export const updateJobApplicantMessage = (
  contactId: number,
  messageId: number,
  jobApplicantId: number,
  update: Partial<Message>,
) =>
  createGenericDispatcher({
    name: 'UPDATE_JOB_MESSAGE',
    loadFunction: () => new Contact(contactId).updateMessage(messageId, { jobApplicantId }, update),
    args: {
      contactId,
      messageId,
      jobApplicantId,
      update,
    },
  });
